export default "__VITE_ASSET__8520d7f9__"